const BirthCountryCode = [
    
  { code: "IND", name: "India" },
  { code: "AFG", name: "Afghanistan" },
  { code: "ALB", name: "Albania" },
  { code: "DZA", name: "Algeria" },
  { code: "ASM", name: "American Samoa" },
  { code: "AND", name: "Andorra" },
  { code: "AGO", name: "Angola" },
  { code: "AIA", name: "Anguilla" },
  { code: "ATA", name: "Antarctica" },
  { code: "ATG", name: "Antigua and Barbuda" },
  { code: "ARG", name: "Argentina" },
  { code: "ARM", name: "Armenia" },
  { code: "ABW", name: "Aruba" },
  { code: "AUS", name: "Australia" },
  { code: "AUT", name: "Austria" },
  { code: "AZE", name: "Azerbaijan" },
  { code: "BHR", name: "BAHRAIN" },
  { code: "1", name: "BERMUDA" },
  { code: "BHS", name: "BahamasThe" },
  { code: "BAN", name: "Bangladesh" },
  { code: "BRB", name: "Barbados" },
  { code: "BLR", name: "Belarus" },
  { code: "BEL", name: "Belgium" },
  { code: "BLZ", name: "Belize" },
  { code: "BEN", name: "Benin" },
  { code: "BTN", name: "Bhutan" },
  { code: "BOL", name: "Bolivia" },
  { code: "BIH", name: "Bosnia and Herzegovina" },
  { code: "BWA", name: "Botswana" },
  { code: "BRA", name: "Brazil" },
  { code: "IOT", name: "British Indian Ocean Territory" },
  { code: "VGB", name: "British Virgin Islands" },
  { code: "BRN", name: "Brunei Darussalam" },
  { code: "BG", name: "Bulgaria" },
  { code: "BFA", name: "Burkina Faso" },
  { code: "BDI", name: "Burundi" },
  { code: "CAN", name: "CANADA" },
  { code: "CAN", name: "CONGO" },
  { code: "CY", name: "CYPRUS" },
  { code: "KHM", name: "Cambodia" },
  { code: "CMR", name: "Cameroon" },
  { code: "CPV", name: "Cape Verde" },
  { code: "CYM", name: "Cayman Islands" },
  { code: "CAF", name: "Central African Republic" },
  { code: "TCD", name: "Chad" },
  { code: "CLY", name: "Chile" },
  { code: "CHN", name: "China" },
  { code: "CXR", name: "Christmas Island" },
  { code: "CCK", name: "Cocos (Keeling) Islands" },
  { code: "COL", name: "Colombia" },
  { code: "COM", name: "Comoros" },
  { code: "COK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "Cote d Ivoire" },
  { code: "HRV", name: "Croatia" },
  { code: "CUB", name: "Cuba" },
  { code: "CUW", name: "Curacao" },
  { code: "CZE", name: "Czech Republic" },
  { code: "DEN", name: "DENMARK" },
  { code: "DMA", name: "DOMINICA" },
  { code: "COD", name: "Democratic Republic of the Congo" },
  { code: "DJI", name: "Dominican Republic" },
  { code: "DOM", name: "Djibouti" },
  { code: "ECU", name: "Ecuador" },
  { code: "EGY", name: "Egypt" },
  { code: "SLV", name: "El Salvador" },
  { code: "ENG", name: "England" },
  { code: "GNQ", name: "Equatorial Guinea" },
  { code: "ERI", name: "Eritrea" },
  { code: "EST", name: "Estonia" },
  { code: "ETH", name: "Ethiopia" },
  { code: "EUR", name: "Europe" },
  { code: "FLK", name: "Falkland Islands (Islas Malvinas)" },
  { code: "FRO", name: "Faroe Islands" },
  { code: "FJI", name: "Fiji" },
  { code: "FIN", name: "Finland" },
  { code: "FRA", name: "France" },
  { code: "PYF", name: "French Polynesia" },
  { code: "GBN", name: "Gabon" },
  { code: "GMB", name: "GambiaThe" },
  { code: "GEO", name: "Georgia" },
  { code: "GER", name: "Germany" },
  { code: "GHA", name: "Ghana" },
  { code: "GIB", name: "Gibraltar" },
  { code: "GRC", name: "Greece" },
  { code: "GRL", name: "Greenland" },
  { code: "GRD", name: "Grenada" },
  { code: "GUM", name: "Guam" },
  { code: "GTM", name: "Guatemala" },
  { code: "GGY", name: "Guernsey" },
  { code: "GIN", name: "Guinea" },
  { code: "GNB", name: "Guinea-Bissau" },
  { code: "GUY", name: "Guyana" },
  { code: "HKG", name: "HONG KONG" },
  { code: "HTI", name: "Haiti" },
  { code: "VAT", name: "Holy See (Vatican City)" },
  { code: "HND", name: "Honduras" },
  { code: "HUN", name: "Hungary" },
  { code: "IREL", name: "IRELAND" },
  { code: "ITA", name: "ITALLY" },
  { code: "ISL", name: "Iceland" },
  { code: "INA", name: "Indonesia" },
  { code: "IRN", name: "Iran" },
  { code: "IRQ", name: "Iraq" },
  { code: "IMN", name: "Isle of Man" },
  { code: "ISR", name: "Israel" },
  { code: "JO", name: "JORDAN" },
  { code: "JAM", name: "Jamaica" },
  { code: "JPN", name: "Japan" },
  { code: "JEY", name: "Jersey" },
  { code: "KWT", name: "KUWAIT" },
  { code: "KAZ", name: "Kazakhstan" },
  { code: "KEN", name: "Kenya" },
  { code: "KIR", name: "Kiribati" },
  { code: "KOR", name: "KoreaDemocratic Peoples Republic" },
  { code: "PRK", name: "KoreaRepublic of" },
  { code: "KGZ", name: "Kyrgyzstan" },
  { code: "LIB", name: "LIBERIA" },
  { code: "LBY", name: "LIBYA" },
  { code: "LAO", name: "Laos" },
  { code: "LVA", name: "Latvia" },
  { code: "LBN", name: "Lebanon" },
  { code: "LSO", name: "Lesotho" },
  { code: "LIE", name: "Liechtenstein" },
  { code: "LTU", name: "Lithuania" },
  { code: "LUX", name: "Luxembourg" },
  { code: "MAC", name: "Macau" },
  { code: "MKD", name: "Macedoniathe former Yugoslav" },
  { code: "MDG", name: "Madagascar" },
  { code: "MWI", name: "Malawi" },
  { code: "MYS", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "MLI", name: "Mali" },
  { code: "MLT", name: "Malta" },
  { code: "MHL", name: "Marshall Islands" },
  { code: "MRT", name: "Mauritania" },
  { code: "MUS", name: "Mauritius" },
  { code: "MYT", name: "Mayotte" },
  { code: "MEX", name: "Mexico" },
  { code: "FSM", name: "MicronesiaFederated States of" },
  { code: "MDA", name: "MoldovaRepublic of" },
  { code: "MCO", name: "Monaco" },
  { code: "MNG", name: "Mongolia" },
  { code: "MNE", name: "Montenegro" },
  { code: "MSR", name: "Montserrat" },
  { code: "MAR", name: "Morocco" },
  { code: "MOZ", name: "Mozambique" },
  { code: "MMR", name: "Myanmar" },
  { code: "NAM", name: "Namibia" },
  { code: "NRU", name: "Nauru" },
  { code: "NEP", name: "Nepal" },
  { code: "NET", name: "Netherland" },
  { code: "ANT", name: "Netherlands Antilles" },
  { code: "NCL", name: "New Caledonia" },
  { code: "NZL", name: "New Zealand" },
  { code: "NIC", name: "Nicaragua" },
  { code: "NER", name: "Niger" },
  { code: "NGA", name: "Nigeria" },
  { code: "NIU", name: "Niue" },
  { code: "NKR", name: "North Korea" },
  { code: "MNP", name: "Northern Mariana Islands" },
  { code: "NOR", name: "Norway" },
  { code: "OMN", name: "OMAN" },
  { code: "PAK", name: "Pakistan" },
  { code: "PLW", name: "Palau" },
  { code: "PAN", name: "Panama" },
  { code: "PNG", name: "Papua New Guinea" },
  { code: "PRY", name: "Paraguay" },
  { code: "PER", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PCN", name: "Pitcairn Islands" },
  { code: "POL", name: "Poland" },
  { code: "PRT", name: "Portugal" },
  { code: "PRI", name: "Puerto Rico" },
  { code: "QAT", name: "Qatar" },
  { code: "IRL", name: "Republic of Ireland" },
  { code: "REU", name: "Reunion" },
  { code: "ROU", name: "Romania" },
  { code: "RUS", name: "RRussiamania" },
  { code: "RWA", name: "Rwanda" },
  { code: "+44", name: "SCOTLAND" },
  { code: "SOM", name: "SOMALIA" },
  { code: "SWE", name: "SOMSWEDENALIA" },
  { code: "SYR", name: "SYRIA" },
  { code: "BLM", name: "Saint Barthelemy" },
  { code: "KNA", name: "Saint Kitts and Nevis" },
  { code: "LCA", name: "Saint Lucia" },
  { code: "MAF", name: "Saint Martin-French part" },
  { code: "SPM", name: "Saint Pierre and Miquelon" },
  { code: "VCT", name: "Saint Vincent and the Grenadines" },
  { code: "WSM", name: "Samoa" },
  { code: "SMR", name: "San Marino" },
  { code: "STP", name: "Sao Tome and Principe" },
  { code: "SAU", name: "Saudi Arabia" },
  { code: "SEN", name: "Senegal" },
  { code: "SRB", name: "Serbia" },
  { code: "SYC", name: "Seychelles" },
  { code: "SLE", name: "Sierra Leone" },
  { code: "SGP", name: "Singapore" },
  { code: "SVK", name: "Slovakia" },
  { code: "SVN", name: "Slovenia" },
  { code: "SLB", name: "Solomon Island" },
  { code: "ZA", name: "South Africa" },
  { code: "SA", name: "South America" },
  { code: "SKR", name: "South Korea" },
  { code: "SSD", name: "South Sudan" },
  { code: "SPN", name: "Spain" },
  { code: "SRI", name: "Sri Lanka" },
  { code: "SUD", name: "Sudan" },
  { code: "SUR", name: "Suriname" },
  { code: "SJM", name: "Svalbard and Jan Mayen" },
  { code: "SWZ", name: "Swaziland" },
  { code: "CHE", name: "Switzerland" },
  { code: "TAI", name: "TAIWAN" },
  { code: "TANZ", name: "TANZANIA" },
  { code: "TUR", name: "TURKEY" },
  { code: "TJK", name: "Tajikistan" },
  { code: "TZA", name: "Tanzania" },
  { code: "THA", name: "Thailand" },
  { code: "TGO", name: "Togo" },
  { code: "TKL", name: "Tokelau" },
  { code: "TON", name: "Tonga" },
  { code: "TTO", name: "Trinidad and Tobago" },
  { code: "TUN", name: "Tunisia" },
  { code: "TKM", name: "Turkmenistan" },
  { code: "TCA", name: "Turks and Caicos Islands" },
  { code: "TUV", name: "Tuvalu" },
  { code: "UGA", name: "Uganda" },
  { code: "UKR", name: "Ukraine" },
  { code: "UAE", name: "United Arab Emirates" },
  { code: "UK", name: "United Kingdom" },
  { code: "USA", name: "United State of America" },
  { code: "URY", name: "Uruguay" },
  { code: "UZB", name: "Uzbekistan" },
  { code: "VUT", name: "Vanuatu" },
  { code: "VEN", name: "VenezuelaBolivarian Republic of" },
  { code: "VNM", name: "Vietnam" },
  { code: "VIR", name: "Virgin IslandsU.S." },
  { code: "WAF", name: "WEST AFRICAN" },
  { code: "WLF", name: "Wallis and Futuna" },
  { code: "ESH", name: "Western Sahara" },
  { code: "967", name: "YEMEN" },
  { code: "ZMB", name: "ZAMBIA" },
  { code: "ZWE", name: "Zimbabwe" },
  
]
export default BirthCountryCode;